import classes from "../SeedLister.module.css"
import { useTranslation } from "react-i18next"
import Calendar from "react-calendar"
import "react-calendar/dist/Calendar.css"
const Control = props => {
    const { t } = useTranslation()

    return (
        <div className={classes.Wrapper}>
            {
                <Calendar
                    value={props.selectValue}
                    onChange={props.selectChange}
                    maxDate={new Date(2025, 10, 31, 1)}
                    minDate={new Date(2024, 10, 31, 0)}
                    className={classes.calendar}
                />
            }
            <div>
                <button className={classes.Button} onClick={props.calculateResults}>
                    {t("misc:Checker.ButtonDisplayResults")}
                </button>
            </div>
        </div>
    )
}

export default Control
